// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.97.1/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.97.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pane.systems-pane {
  color: var(--color-elevated-text);
  display: grid;
  gap: 2rem;
  grid-template-columns: 25rem auto;
  line-height: 1.5rem;
  text-align: left;
}
.pane.systems-pane .list {
  margin-top: 2px;
}
.pane.systems-pane .list .item.systems-item {
  margin: 0;
  padding: 0;
}
.pane.systems-pane .system-identifier {
  margin: 0;
}
.pane.systems-pane .active.systems-item .system-card.control-server {
  border-color: var(--color-elevated-success) !important;
}
.pane.systems-pane .active.systems-item .system-card.control-server .system-identifier {
  color: var(--color-elevated-success) !important;
}
.pane.systems-pane .systems-item {
  position: relative;
}
.pane.systems-pane .systems-item .icon.detail-collapse, .pane.systems-pane .systems-item .icon.detail-expand {
  height: 1.5rem;
  position: absolute;
  top: calc(50% - 0.75rem);
  right: 1rem;
}
.pane.systems-pane .systems-item .icon.detail-expand {
  fill: var(--color-base-draw);
}
.pane.systems-pane .systems-item .icon.detail-collapse {
  fill: var(--color-elevated-success);
}
.pane.systems-pane .system-card {
  background-color: var(--color-elevated-canvas);
  border-bottom: var(--border-elevated);
  border-top: var(--border-elevated);
  padding: 0.5rem 0 0.5rem 1.5rem;
  margin-top: -1px;
}
.pane.systems-pane .system-card.available .system-availability .data-value {
  color: var(--color-elevated-draw);
}
.pane.systems-pane .system-card.available .icon.status-circle {
  fill: var(--color-elevated-draw);
  height: 0.5rem;
  margin-left: 0.4rem;
}
.pane.systems-pane .system-card.unavailable .system-availability .data-value, .pane.systems-pane .system-card.commands-paused .system-availability .data-value {
  color: var(--color-elevated-warn);
}
.pane.systems-pane .system-card.unavailable .system-common-display, .pane.systems-pane .system-card.unavailable .control-server-display {
  opacity: 0.4;
}
.pane.systems-pane .system-card .control-server-locked-at {
  color: var(--color-elevated-warn);
}
.pane.systems-pane .system-card .control-server-locked-at .data-label, .pane.systems-pane .system-card .control-server-locked-at .data-value {
  color: var(--color-elevated-warn);
}
.pane.systems-pane .calibration-display.empty {
  clear: both;
  margin: 4rem;
  text-align: center;
  width: 28rem;
}
.pane.systems-pane .qubits-display .identifier {
  font-size: 1.2rem;
  position: absolute;
  text-align: center;
  margin: 2rem 4rem 4rem 4rem;
  width: 28rem;
}
.pane.systems-pane .available .identifier {
  opacity: 1;
}
.pane.systems-pane .no-control-server {
  color: var(--color-base-text);
  margin-top: 3rem;
  text-align: center;
}
.pane.systems-pane .calibration-card .identifier {
  color: var(--color-elevated-success);
}
.pane.systems-pane .calibration-table {
  border-collapse: collapse;
  float: left;
  margin: 0 2rem 2rem 2rem;
  table-layout: fixed;
  border: var(--border-width) solid var(--color-base-canvas);
}
.pane.systems-pane .calibration-table td, .pane.systems-pane .calibration-table th {
  border: 1px solid var(--color-base-border);
  padding: 0.5rem 1rem;
}
.pane.systems-pane .calibration-table th {
  color: var(--color-elevated-hint);
  font-weight: normal;
}
.pane.systems-pane .calibration-table tbody tr:nth-child(odd) {
  background-color: var(--color-base-canvas);
}
.pane.systems-pane .calibration-table .component {
  text-align: right;
  width: 4rem;
}
.pane.systems-pane .calibration-table .epg {
  text-align: right;
  width: 6rem;
}
.pane.systems-pane .calibration-table .timestamp {
  color: var(--color-elevated-hint);
  text-align: left;
  min-width: 8rem;
}
.pane.systems-pane .qubit-arrangement {
  float: left;
  text-align: center;
  margin: 1rem 4rem 4rem 4rem;
  width: 28rem;
}
.pane.systems-pane .qubit-arrangement .icon {
  fill: none;
  stroke: var(--color-base-draw);
  stroke-width: 3px;
}
.pane.systems-pane .qubit-arrangement .label {
  fill: var(--color-elevated-draw);
  font-weight: lighter;
}
.pane.systems-pane .qubit-arrangement .qubit-arranagement-dr {
  opacity: 0.7;
  font-weight: normal;
}
.pane.systems-pane .qubit-arrangement .label-backdrop {
  fill: var(--color-elevated-canvas);
  stroke: var(--color-elevated-canvas);
  stroke-width: 10px;
}
.pane.systems-pane .qubit-arrangement .coupler .label {
  font-size: 14px;
}
.pane.systems-pane .qubit-arrangement .qubit .label {
  font-size: 20px;
  font-weight: bold;
}

@media (prefers-color-scheme: light) {
  .windows .available .system-availability .data-value {
    font-weight: 500;
  }
  .windows .available.commands-paused .system-availability .data-value {
    font-weight: normal;
  }
}`, "",{"version":3,"sources":["webpack://./src/style/panes/systems.scss"],"names":[],"mappings":"AAAA;EACE,iCAAA;EACA,aAAA;EACA,SAAA;EACA,iCAAA;EACA,mBAAA;EACA,gBAAA;AACF;AACE;EACE,eAAA;AACJ;AACE;EACE,SAAA;EACA,UAAA;AACJ;AAEE;EACE,SAAA;AAAJ;AAII;EACE,sDAAA;AAFN;AAIM;EACE,+CAAA;AAFR;AAOE;EAEE,kBAAA;AANJ;AAkBI;EACE,cAAA;EACA,kBAAA;EACA,wBAAA;EACA,WAAA;AAhBN;AAkBI;EACE,4BAAA;AAhBN;AAkBI;EACE,mCAAA;AAhBN;AAoBE;EACE,8CAAA;EACA,qCAAA;EACA,kCAAA;EACA,+BAAA;EACA,gBAAA;AAlBJ;AAqBM;EACE,iCAAA;AAnBR;AAqBM;EACE,gCAAA;EACA,cAAA;EACA,mBAAA;AAnBR;AAuBM;EACE,iCAAA;AArBR;AAyBM;EACE,YAAA;AAvBR;AA2BI;EACE,iCAAA;AAzBN;AA0BM;EACE,iCAAA;AAxBR;AA6BE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;AA3BJ;AA8BE;EACE,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,2BAAA;EACA,YAAA;AA5BJ;AA+BE;EACE,UAAA;AA7BJ;AAgCE;EACE,6BAAA;EACA,gBAAA;EACA,kBAAA;AA9BJ;AAiCE;EACE,oCAAA;AA/BJ;AAkCE;EACE,yBAAA;EACA,WAAA;EACA,wBAAA;EACA,mBAAA;EAEA,0DAAA;AAjCJ;AAmCI;EACE,0CAAA;EACA,oBAAA;AAjCN;AAoCI;EACE,iCAAA;EACA,mBAAA;AAlCN;AAqCI;EACE,0CAAA;AAnCN;AAsCI;EACE,iBAAA;EACA,WAAA;AApCN;AAsCI;EACE,iBAAA;EACA,WAAA;AApCN;AAsCI;EACE,iCAAA;EACA,gBAAA;EACA,eAAA;AApCN;AAwCE;EACE,WAAA;EACA,kBAAA;EACA,2BAAA;EACA,YAAA;AAtCJ;AAwCI;EACE,UAAA;EACA,8BAAA;EACA,iBAAA;AAtCN;AAyCI;EACE,gCAAA;EACA,oBAAA;AAvCN;AA0CI;EACE,YAAA;EACA,mBAAA;AAxCN;AA2CI;EACE,kCAAA;EACA,oCAAA;EACA,kBAAA;AAzCN;AA4CI;EACE,eAAA;AA1CN;AA6CI;EACE,eAAA;EACA,iBAAA;AA3CN;;AAgDA;EACE;IACE,gBAAA;EA7CF;EA+CA;IACE,mBAAA;EA7CF;AACF","sourcesContent":[".pane.systems-pane {\n  color: var(--color-elevated-text);\n  display: grid;\n  gap: 2rem;\n  grid-template-columns: 25rem auto;\n  line-height: 1.5rem;\n  text-align: left;\n\n  .list {\n    margin-top: 2px;\n  }\n  .list .item.systems-item {\n    margin: 0;\n    padding: 0;\n  }\n\n  .system-identifier {\n    margin: 0;\n  }\n\n  .active.systems-item {\n    .system-card.control-server {\n      border-color: var(--color-elevated-success) !important;\n\n      .system-identifier {\n        color: var(--color-elevated-success) !important;\n      }\n    }\n  }\n\n  .systems-item {\n    // padding: 1rem 1rem 0 1.5rem;\n    position: relative;\n\n    &:last-child .system-card {\n      // border-bottom: none;\n    }\n\n    // &.active {\n    //   background-color: var(--color-selected-canvas);\n    //   margin-top: calc(-1 * var(--border-width));\n    //   padding-top: calc(1rem + var(--border-width));\n    // }\n\n    .icon.detail-collapse, .icon.detail-expand {\n      height: 1.5rem;\n      position: absolute;\n      top: calc(50% - 0.75rem);\n      right: 1rem;\n    }\n    .icon.detail-expand {\n      fill: var(--color-base-draw);\n    }\n    .icon.detail-collapse {\n      fill: var(--color-elevated-success);\n    }\n  }\n\n  .system-card {\n    background-color: var(--color-elevated-canvas);\n    border-bottom: var(--border-elevated);\n    border-top: var(--border-elevated);\n    padding: 0.5rem 0 0.5rem 1.5rem;\n    margin-top: -1px;\n\n    &.available {\n      .system-availability .data-value {\n        color: var(--color-elevated-draw);\n      }\n      .icon.status-circle {\n        fill:  var(--color-elevated-draw);\n        height: 0.5rem;\n        margin-left: 0.4rem;\n      }\n    }\n    &.unavailable, &.commands-paused {\n      .system-availability .data-value {\n        color: var(--color-elevated-warn);\n      }\n    }\n    &.unavailable {\n      .system-common-display, .control-server-display {\n        opacity: 0.4;\n      }\n    }\n\n    .control-server-locked-at {\n      color: var(--color-elevated-warn);\n      .data-label, .data-value {\n        color: var(--color-elevated-warn);\n      }\n    }\n  }\n\n  .calibration-display.empty {\n    clear: both;\n    margin: 4rem;\n    text-align: center;\n    width: 28rem;\n  }\n\n  .qubits-display .identifier {\n    font-size: 1.2rem;\n    position: absolute;\n    text-align: center;\n    margin: 2rem 4rem 4rem 4rem;\n    width: 28rem;\n  }\n\n  .available .identifier {\n    opacity: 1;\n  }\n\n  .no-control-server {\n    color: var(--color-base-text);\n    margin-top: 3rem;\n    text-align: center;\n  }\n\n  .calibration-card .identifier {\n    color: var(--color-elevated-success);\n  }\n\n  .calibration-table {\n    border-collapse: collapse;\n    float: left;\n    margin: 0 2rem 2rem 2rem;\n    table-layout: fixed;\n\n    border: var(--border-width) solid var(--color-base-canvas);\n\n    td, th {\n      border: 1px solid var(--color-base-border);\n      padding: 0.5rem 1rem;\n    }\n\n    th {\n      color: var(--color-elevated-hint);\n      font-weight: normal;\n    }\n\n    tbody tr:nth-child(odd) {\n      background-color: var(--color-base-canvas);\n    }\n\n    .component {\n      text-align: right;\n      width: 4rem;\n    }\n    .epg {\n      text-align: right;\n      width: 6rem;\n    }\n    .timestamp {\n      color: var(--color-elevated-hint);\n      text-align: left;\n      min-width: 8rem;\n    }\n  }\n\n  .qubit-arrangement {\n    float: left;\n    text-align: center;\n    margin: 1rem 4rem 4rem 4rem;\n    width: 28rem;\n\n    .icon {\n      fill: none;\n      stroke: var(--color-base-draw);\n      stroke-width: 3px;\n    }\n\n    .label {\n      fill: var(--color-elevated-draw);\n      font-weight: lighter;\n    }\n\n    .qubit-arranagement-dr {\n      opacity: 0.7;\n      font-weight: normal;\n    }\n\n    .label-backdrop {\n      fill: var(--color-elevated-canvas);\n      stroke: var(--color-elevated-canvas);\n      stroke-width: 10px;\n    }\n\n    .coupler .label {\n      font-size: 14px;\n    }\n\n    .qubit .label {\n      font-size: 20px;\n      font-weight: bold;\n    }\n  }\n}\n\n@media (prefers-color-scheme: light) {\n  .windows .available .system-availability .data-value {\n    font-weight: 500;\n  }\n  .windows .available.commands-paused .system-availability .data-value {\n    font-weight: normal;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
